

import { ID, Response } from "../../../../../_metronic/helpers"

export type Chapter = {
  id?: ID
  name?: string
  avatar?: string
  email?: string
  position?: string
  role?: string
  title?:string
  notification_type?:string
 
}

export type ChaptersQueryResponse = Response<Array<Chapter>>

export const initialChapter: Chapter = {
  avatar: 'avatars/300-6.jpg',
  position: 'Art Director',
  role: 'Administrator',
  name: '',
  email: '',

}
